import react, { useState, useEffect } from "react";
import { fetchApi } from "../services/requests";
import queryString from "query-string";

const defaultParams = {
  site: 12,
  visibility: "site",
  ordering: "-published_at",
};

export function useArticlesBoxes(id, userId) {
  const [pollId, setPollId] = useState(null);
  const [poll, setPoll] = useState(null);
  const [videoId, setVideoId] = useState(null);
  const [video, setVideo] = useState(null);
  const [productId, setProductId] = useState(null);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const getBoxes = async () => {
      const [resp] = await fetchApi({
        url: `articles-article-boxes/${id}`,
      });
      if (resp) {
        resp.poll && setPollId(resp.poll);
        resp.video && setVideoId(resp.video);
        resp.product && setProductId(resp.product);
      }
    };
    getBoxes();
  }, []);

  useEffect(() => {
    const getPoll = async () => {
      const [resp] = await fetchApi({
        url: `polls-poll/${pollId}`,
      });
      if (resp) {
        resp && setPoll(resp);
      }
    };

    pollId && getPoll();
  }, [pollId]);

  useEffect(() => {
    const getVideo = async () => {
      const [resp] = await fetchApi({
        url: `videos-video/${videoId}?user_id=${userId}`,
      });
      if (resp) {
        resp && setVideo(resp);
      }
    };
    videoId && getVideo();
  }, [videoId]);

  useEffect(() => {
    const getProduct = async () => {
      const [resp] = await fetchApi({
        url: `blocks-agrarsklep-product/?id=${productId}`,
      });
      if (resp) {
        resp.count && setProduct(resp.results[0]);
      }
    };
    productId && getProduct();
  }, [productId]);

  return { poll, video, product };
}
